// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem, Label, Input } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtn";
import ViewProcessLeaves from "./ViewProcessLeaves";
import DropDownActions from "../../common/DropDownActions";
import api from "../../../apis/api";
import Notifications from "../../../components/common/Notifications";
import moment from 'moment';
import {
  PopUp,
  PopUpSuccess,
  } from "../../../components/adminSettings/index";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ListMyAppliedLeaves = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handledelAppliedLeaves,
    handelFromDate,
    handelToDate,
    handlerecholidayCalendarArray,
    handleleavestatus,
    handleholidayCalendarArray,
  }) => {
    const [thead] = useState([
      "Type",
      "Applied",
      "DateFrom",
      "DateTo",
      "Days",
      "Status",
      "ApprovedDate",
      "RejectedDate",
      "Action",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [leavelist,setleavelist]=useState([]);
    const [myleavedetailedlist,setmyleavelist]=useState([]);
    const [myappliedleavelist,setmyappliedleavelist]=useState([]);
    const [dateArray,setDateArray]=useState([]);
    const [leaverequestDetails, setLeaverequestDetails] = useState([]);
    const [islistview,setislistview] =useState(true);
    const [isDetailedview,setdetailedview] =useState(false);
    const [holidayCalendarArray,setholidayCalendarArray] = useState([]);
     const [error, setError] = useState(null);
      const [isopenpopup,setisopenpopup]=useState(false);
      const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
      const [curDelId,setcurDelId] =useState(0);
    useEffect(() => {
      setleavelist(empTask);
    },[empTask])
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

const handleDelAppliedleave = React.useCallback(
    (CalendarYear) => {
      setisopenpopup((prevState) => !prevState);
      setcurDelId(CalendarYear);
    });
  const hadleDelWithPopYes =React.useCallback(() =>{
    // const res= delOfficeLoation(curDelId);
    handledelAppliedLeaves(parseInt(curDelId)); 
    setisopenpopup((prevState) => !prevState);
    setisopenpopupSuccess((prevState) => !prevState);
    
   
    }, [handledelAppliedLeaves,curDelId]);

  const hadleDelWithPopNo =React.useCallback(() =>{
   setisopenpopup((prevState) => !prevState);
  
  });
    
 const hadleSuccessPop =React.useCallback(() =>{
   setisopenpopupSuccess((prevState) => !prevState);
   setError({ ...error, message: "Applied leave deleted successfully..", status: 200 });
   setTimeout(() => { 
    window.location.reload();
   }, 3000);
  });

    const getDates = (arrlist) => {
      const dates = [];
      arrlist.forEach(element => {
        if (element.fromDate && element.toDate) {
          const start = new Date(element.fromDate);
          const end = new Date(element.toDate);
          const days = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          
          for (let i = 0; i <= days; i++) {
              const currentDate = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
              dates.push(moment(currentDate).format("DD-MM-YYYY"));
          }
        
      }
      });
      setDateArray(dates);
  };
    const handleDetails=React.useCallback((leaverequestId,employeeId)=>{
      // setIsOpen(true);
      const fetchApi = async () => {
        let arr=[];
        let arr1=[];
        let arr2=[];
        let arr3=[];
        await api
        .dbLeaveTypes()
        .GetLeaveRequestById(parseInt(leaverequestId))
        .then((res) =>setLeaverequestDetails(res.data));
        await api
        .dbLeaveTypes()
        .GetLeaveTypesByEmpId(parseInt(employeeId))
        .then((res) =>arr.push(res.data));
        
        await api
        .dbLeaveTypes()
        .GetAppliedLeavesByEmpId(parseInt(employeeId))
        .then((res) =>arr2.push(res.data));
      
    
        await api
        .dbLeaveTypes()
        .GetAppliedLeavesByRequestId(parseInt(leaverequestId))
        .then((res) =>arr1.push(res.data));

        await api
        .dbcalendar()
        .GetHolidayCalendarList()
        .then((res) => arr3.push(res.data));
    
        setmyleavelist(arr[0]);
        setmyappliedleavelist(arr1[0]);
        getDates(arr2[0]);
        setholidayCalendarArray(arr3[0]);
        setislistview(false);
        setdetailedview(true);
      }
      fetchApi();
    
    })

  //  const handledelAppliedleave =React.useCallback((leave) =>{
  //   delAppliedLeaves(leave);
  //  },[delAppliedLeaves])

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);

    const toggleview =React.useCallback(() =>{
      setislistview((prevState) => !prevState);
      setdetailedview((prevState) => !prevState);
    },[setislistview,setdetailedview]);

    useEffect(() => {
      let sortedTasks = [...empTask].sort((a, b) => a.leaveTypeId - b.leaveTypeId);

      let trow = sortedTasks.map((el) => ({
        Type:<div style={{width:'100px'}}>{el.type}</div>,
        Applied:<div style={{width:'100px'}}>{moment(el.createdDate).format("DD-MM-YYYY")}</div>,
        DateFrom:<div style={{width:'100px'}}>{moment(el.fromDate).format("DD-MM-YYYY")}</div>,
        DateTo:<div style={{width:'100px'}}>{moment(el.toDate).format("DD-MM-YYYY")}</div>,
        Days:<div style={{width:'50px'}}>{el.noOfDays}</div>,
        Status:<div style={{width:'50px'}}>{el.leaveStatus}</div>,
        ApprovedDate : <div style={{width:'100px'}}>{el.approvedDate =='0001-01-01T00:00:00' ? null : (moment(el.approvedDate).format("DD-MM-YYYY"))}</div>,
        RejectedDate : <div style={{width:'100px'}}>{el.rejectedDate=='0001-01-01T00:00:00' ? null : (moment(el.rejectedDate).format("DD-MM-YYYY"))}</div>,
        Action:<div style={{ width: "70px" }}>
       {el.leaveStatus == "Pending" && el.isAuto != true ? (<DropDownActions
          dropDownOption={[
            {action: "Cancel", handleAction: () => handleDelAppliedleave(el.leaveRequestId)},
            { action: "View", handleAction: () => handleDetails(el.leaveRequestId,el.employeeId) },
          ]}
        ></DropDownActions>) : (<DropDownActions
          dropDownOption={[
           
            { action: "View", handleAction: () => handleDetails(el.leaveRequestId,el.employeeId) },
          ]}
        ></DropDownActions>)} 
      </div>
        // CarryForwarded:<div style={{width:'100px'}}>{el.noOfLeavesCarryForwarded}</div>,
      
      }));

      setTrow(trow);
    }, []);
    
    return (
      <Fragment>

          {/* <div className="row">

          <div className="col-md-3">
          <Label for="exampleEmail">From Date</Label>
                <Input
                  type="date"
                  // value={warrantyEndDate}
                  onChange={(e) => handelFromDate(e.target.value)}
                />
          </div>
          <div className="col-md-3">
          <Label for="exampleEmail">To Date</Label>
                <Input
                  type="date"
                  // value={warrantyEndDate}
                   onChange={(e) => handelToDate(e.target.value)}
                />
          </div>

            &nbsp;

          </div> */}
       <br/>
       {islistview == true ? ( <div className="" style={{ maxWidth: maxwidth, overflowY: "auto" }}>
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5}></TableWithSortPagtn>
      </div>) : null} 
    {isDetailedview == true ? ( <ViewProcessLeaves
leaverequestDetails={leaverequestDetails}
myleavedetailedlist={myleavedetailedlist}
myappliedleavelist={myappliedleavelist}
holidayCalendarArray={holidayCalendarArray}
handlerecholidayCalendarArray={handlerecholidayCalendarArray}
handleleavestatus={handleleavestatus}
empTask={empTask}
handleSelectedTask={handleSelectedTask}
handleDelTask={handleDelTask}
dateArray={dateArray}
toggleview={toggleview}
></ViewProcessLeaves>) : null}
        {/* <div className="mt-3">
          <ListGroup className="task-list ">
            {empTask.map((tasks, i) => (
              <ListGroupItem
                key={i}
                onClick={() => handleOnclickSelectedTask(tasks, i)}
                style={i === activeTask ? active : null}
              >
                <div className="task-container ">
                  <span className="task-check">
                  {tasks.timeSheetStatus ==3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green'}}></i>) : <i className="fas fa-check  project-task-icon"></i>}
                    
                  </span>
                  <span className="task-label">{tasks.description}</span>
                  <span className="task-label">{tasks.hoursSpent}</span>
                  <span className="task-label">{tasks.timeSheetStatus}</span>
                  <span className="task-action-btn task-btn-right">
                    <span
                      className="action-circle large task-assign"
                      title="Assign"
                    >
                      <i className="fas fa-user  project-task-icon"></i>
                    </span>
                    <span
                      className="action-circle large delete-btn"
                      title="Delete Task"
                      onClick={() => DelTask(tasks.employeeTimeSheetId)}
                    >
                      <i className="fas fa-trash project-task-icon"></i>
                    </span>
                  </span>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div> */}
         <Notifications notifications={error}></Notifications>
      {isopenpopup == true ? (<PopUp 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUp>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
      </Fragment>
    );
  }
);

export default ListMyAppliedLeaves;
